"use client";
import { Stack, Typography, Divider, Box } from "@mui/material";

import { useStore, observer } from "service/mobx";
import ButtonText from "component/Button/Text";
import { dialogFeedback } from "component/Dialog/dialogs/appWide/Feedback";

export default function Footer() {
  const { dialog } = useStore();

  return (
    <Box mt={2}>
      <Divider variant="middle" sx={{ borderColor: "outline.variant" }} />
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        py={1}
        px={2}
      >
        <Typography
          variant="bodySm"
          color="secondary.color"
          sx={{ textWrap: "balance" }}
        >
          Designed for Accessibility and to further Open Science
        </Typography>
        <ButtonText
          size="small"
          label="Send feedback"
          onClick={() => dialog.configure(dialogFeedback)}
        />
      </Stack>
      <License />
    </Box>
  );
}
const License = observer(function License() {
  const { reader } = useStore();
  const paper = reader.paperNode ?? {};

  return paper.publisher === "arxiv" ? (
    <Typography
      paragraph
      px={2}
      variant="labelSm"
      color="secondary.color"
      pb={{ compact: 8, expanded: 0 }}
    >
      Thank you {paper.authorArray?.join(", ") ?? ""}, who authored{" "}
      {paper.title} 🙏 This page is the html of their{" "}
      <a href={`https://arxiv.org/abs/${paper.paperID}`} target="_blank">
        arXiv
      </a>{" "}
      <a href={`https://arxiv.org/pdf/${paper.paperID}`} target="_blank">
        pdf
      </a>
      , with no changes made other than format. Please cite their work
      {paper.license?.url ? (
        <>
          , which is licensed under{" "}
          <Box
            component="a"
            textTransform="capitalize"
            href={paper.license?.url}
            target="_blank"
          >
            {paper.license?.name}
          </Box>
        </>
      ) : null}
    </Typography>
  ) : null;
});
